var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20",
    "data-name": "Group 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.118,
    height: 27.648,
    viewBox: "0 0 22.118 27.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 22.118,
    height: 27.648,
    fill: "#ddd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M215.812,255.46a1.39,1.39,0,0,0-1.382-1.382H203.938l3.179-3.165a1.388,1.388,0,0,0-1.963-1.963l-5.529,5.529a1.429,1.429,0,0,0,0,1.963l5.529,5.529a1.388,1.388,0,1,0,1.963-1.963l-3.179-3.165h10.492a1.39,1.39,0,0,0,1.382-1.382",
    transform: "translate(-193.695 -241.636)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M17.97,0H4.147A4.147,4.147,0,0,0,0,4.148V23.5a4.147,4.147,0,0,0,4.147,4.147H17.97A4.171,4.171,0,0,0,22.117,23.5V19.353a1.382,1.382,0,1,0-2.765,0V23.5a1.391,1.391,0,0,1-1.382,1.382H4.147A1.391,1.391,0,0,1,2.765,23.5V4.148A1.391,1.391,0,0,1,4.147,2.766H17.97a1.391,1.391,0,0,1,1.382,1.382V8.295a1.382,1.382,0,1,0,2.765,0V4.148A4.171,4.171,0,0,0,17.97,0",
    transform: "translate(0 0)",
    fill: "#ddd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.bd63bc3a52df64fcc9203b692cf6e732.svg";
export { ForwardRef as ReactComponent };